export const getSearchTerm = (state) => (state.shop.searchTerm || '');
export const getUser = (state) => (state.user || null);
export const getEvent = (state) => (state.event || null);
export const getCart = (state) => (state.cart || null);
export const getPartner = (state) => (state.partner || null);
export const getPartnerPortalSettings = (state) => (state.partnerPortalSettings.partnerPortalSettings || false);
export const getOrdersMeta = (state) => (state.orders.meta || null);
export const getScanPointsMeta = (state) => (state.orders.meta || null);
export const metaLoaded = (state) => (state.orders.metaLoaded || false);
export const orderRowsMetaLoaded = (state) => (state.orders.orderRowsMetaLoaded || false);
